import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCheckbox,
  CustomModal,
  CustomRadioButton,
  InputPlacaVeiculo,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useVeiculoTransferenciaModal, {
  CATEGORIES,
  LOAD_MESSAGE,
} from './VeiculoTransferenciaModalHook'

function VeiculoTransferenciaModal({
  dispatch,
  selectedTp,
  visible,
  onModalClose,
  onModalSave,
  vehicleTransfer,
}) {
  const { state, localDispatch } = useVeiculoTransferenciaModal()

  useEffect(() => {
    if (visible) localDispatch.onInit(vehicleTransfer)
  }, [visible])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.NEW_VEICULO_TRANSFERENCIA:
        dispatch(showLoadingBox('Aguarde...', 'Salvando novo veiculo de transferência'))
        localDispatch.saveVehicleTransfer(state.vehicleTransfer, selectedTp)
        break

      case LOAD_MESSAGE.UPDATE_VEICULO_TRANSFERENCIA:
        dispatch(showLoadingBox('Aguarde...', 'Atualizando dados do veiculo'))
        localDispatch.updateVehicleTransfer(state.vehicleTransfer)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        onModalSave(state.updatedVehicleTransfer)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      isVisible={visible}
      onClose={() => {
        localDispatch.onClose()
        onModalClose()
      }}
      header={
        state.vehicleTransfer.id
          ? 'Editando Veiculo de Transferência'
          : 'Novo Veiculo de Transferência'
      }
      width={600}
    >
      <div className="p-grid">
        <div className="p-col-6">
          <InputPlacaVeiculo
            label="Placa :*"
            marginTop={10}
            value={state.vehicleTransfer.vehicle_badge}
            onChange={value => localDispatch.onInputChange('vehicle_badge', value)}
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 40 }}>
          <CustomRadioButton
            items={CATEGORIES}
            value={state.vehicleTransfer.category}
            onChange={value => localDispatch.onInputChange('category', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomCheckbox
            onChange={value => localDispatch.onInputChange('actived', value)}
            checked={state.vehicleTransfer.actived}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClick(state.vehicleTransfer)}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(VeiculoTransferenciaModal)
